import request from '@/utils/request'

export function getByKey(key) {
  return request({
    url: 'administration/adminTable/getByKey/' + key,
    method: 'get',
  });
}

export function getByParent(parent) {
  return request({
    url: 'administration/adminTable/getByParent/' + parent,
    method: 'get',
  });
}

export function edit(id) {
  return request({
    url: 'administration/adminTable/edit/' + id,
    method: 'get',
  });
}

export function destroy(id) {
  return request({
    url: 'administration/adminTable/destroy/' + id,
    method: 'get',
  });
}

export function save(key, value, parent, terms) {
  return request({
    url: 'administration/adminTable/save',
    method: 'post',
    data: { key, value, parent, terms }
  });
}
